import {displayMessage} from './utility/message';
import {MessageType} from './utility/messageTypes';
import {apiRequest} from './utility/apiRequest';
import {Config} from './utility/config'; // Assuming apiRequest is in utility

interface AjaxResponse {
    success: boolean;
    data: {
        message: string;
    };
}

// Main functionality for managing the cart
document.addEventListener('DOMContentLoaded', () => {
    const ambiklyCart = {
        init() {
            this.bindEvents();
        },
        bindEvents() {
            // Combine both event listeners to minimize redundancy
            document.body.addEventListener('input', (e: Event) => {
                const target = e.target as HTMLElement;
                const isQuantityChange = target.classList.contains('ambikly-cart-quantity');

                if (isQuantityChange) {
                    const quantity = (target as HTMLInputElement).value;
                    this.ajax(quantity, target);
                }
            });

            document.body.addEventListener('click', (e: Event) => {
                const target = e.target as HTMLElement;
                const isRemoveClick = target.classList.contains('ambikly-remove-button');

                if (isRemoveClick) {
                    const quantity = '0'; // Set quantity to 0 when removing
                    this.ajax(quantity, target);
                }
            });
        },
        async ajax(quantity: string, target: HTMLElement) {
            const row = target.closest('tr');
            if (!row) return; // Exit early if no row found

            const cartContainer = row.closest('.ambikly-cart-container') as HTMLElement;
            if (!cartContainer) return; // Exit early if no cart container found

            const formData = this.buildFormData(quantity, row, cartContainer);

            try {
                const response = await apiRequest(Config.AJAX_URL ?? '', {

                    method: 'POST',
                    body: formData,
                });

                const data: AjaxResponse = JSON.parse(response);
                if (quantity === '0') row.remove(); // Remove row if quantity is 0

                const messageType = data.success ? MessageType.SUCCESS : MessageType.ERROR;
                displayMessage(cartContainer, data.data.message || 'Failed to update cart.', messageType, true);
            } catch (error) {
                console.error('Error during cart update:', error);
                displayMessage(cartContainer, 'An error occurred while processing your request.', MessageType.ERROR, true);
            }
        },
        buildFormData(quantity: string, row: HTMLElement, cartContainer: HTMLElement): FormData {
            const formData = new FormData();
            formData.append('quantity', quantity);

            const productId = row.getAttribute('data-product-id');
            const ambiklyNonce = (cartContainer.querySelector('input[name="ambikly_nonce"]') as HTMLInputElement)?.value;
            const action = (cartContainer.querySelector('input[name="action"]') as HTMLInputElement)?.value;

            if (productId) formData.append('product_id', productId);
            if (ambiklyNonce) formData.append('ambikly_nonce', ambiklyNonce);
            if (action) formData.append('action', action);

            return formData;
        },
    };

    ambiklyCart.init();
});
